<template>
    <div :id="`project-${project.ProjectID}`" :class="['btn project', Classes().linked]" @mouseenter="Hover(true)" @mouseleave="Hover()">
        <Map
            v-for="(coordinates, c) of TimelineMapping()"
            :key="c"
            :coordinates="coordinates"
            :index="c"
            :project="project"
            :totalDays="TotalDays()"
            :timelineZoom="timelineZoom"
            :show="Show(coordinates.startYear)"
            :showTab="focusedYear === coordinates.startYear"
            :focused="focusedProjectID === project.ProjectID"
            :projectSelected="ProjectSelected(project)"
            :searching="searching"
            @project="$emit('project', $event)"
        />
    </div>
</template>

<script>
import { CONFIG } from "@/assets/JS/Config.js";
import { ASSETS } from "@/assets/JS/Assets.js";
import { TimelineInstance } from "@/assets/JS/Timeline.js";
import Map from "@/components/Timeline/Project/Map/Map.vue";

export default {
    name: "TimelineProject",
    props: {
        coordinates: Object,
        totalYears: Number,
        project: Object,
        index: Number,
        timelineZoom: Number,
        projectYears: Object,
        focusedYear: Number,
        selectedProject: Object,
        searching: Boolean
    },
    components: { Map },
    data: () => ({
        linked: false,
        timelineHeight: 0,
        projectYear: 0,
        focusedProjectID: 0
    }),
    methods: {
        TimelineMapping: function() {
            const coordinateMaps = new TimelineInstance.Project(
                this.timelineHeight,
                CONFIG.timeline.dayHeight,
                this.coordinates,
                this.projectYears.list,
                this.index
            );
            if (coordinateMaps.length > 1) {
                this.linked = true;
            }
            this.projectYear = coordinateMaps[0].startYear;
            return coordinateMaps;
        },
        Classes: function() {
            return {
                linked: this.linked ? "project-linked" : ""
            };
        },
        TotalDays: function() {
            const totalMaps = this.TimelineMapping().length;
            return {
                daySpan: this.TimelineMapping()[totalMaps - 1].totalDays,
                timelineTotalDays: this.timelineHeight * this.totalYears
            };
        },
        Hover: function(over) {

            // Set focused project by its ID
            this.focusedProjectID = over ? this.project.ProjectID : 0;

            this.$emit("hover", {
                projectID: over ? this.project.ProjectID : -1,
                index: over ? this.index : -1,
                year: over ? this.projectYear : 0
            });
        },
        Show: function(startYear) {
            let show;

            // Some projects were dated for the Social Impact priority portion but were not flagged as being of type Social Impact. Here we make that check.
            if (startYear >= this.projectYears.socialImpactStartYear && !this.project.SocialImpact) {
                show = false;

            } else {
                show = true;
            }
            return show;
        },
        ProjectSelected: function(project) {
            const { id, timelineMapID } = this.selectedProject;
            return project.ProjectID === id && project.TimelineProjectMapID === timelineMapID;
        }
    },
    beforeMount: function() {
        this.timelineHeight = ASSETS.Timeline.Height(CONFIG);
    },
    emits: [
        "hover",
        "project",
        "topographies"
    ]
};
</script>